var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"my-7 text-h6"},[_vm._v(_vm._s(_vm._f("globalTranslate")('sentence.confirmation',[_vm.getDateFormated, _vm.getNumberOfDays()])))])}
var staticRenderFns = []

export { render, staticRenderFns }